import React, { useState, useEffect, useRef } from 'react';
import DesktopUserNav from '../App-Components/DesktopUserNav'
import { IoIosArrowDown } from "react-icons/io";
import { MdNotificationsNone } from "react-icons/md";
import { NavLink } from 'react-router-dom';
import logo from "../../stock/nexus/logo.png"
import { CgMenuLeft } from "react-icons/cg";
import UserNav from '../App-Components/MobileUserNav';
import { RiExchangeDollarLine } from "react-icons/ri";
import { BiTransfer } from "react-icons/bi";
import { RiSendPlaneLine } from "react-icons/ri";
import { MdFormatListBulletedAdd } from "react-icons/md";
import purse from '../../stock/purse.png'
import { RiPlayListAddLine } from "react-icons/ri";
import { MdHistory } from "react-icons/md";
import { doc, getDoc, setDoc, updateDoc, collection,addDoc, query, orderBy, getDocs, deleteDoc, where } from 'firebase/firestore';
import { auth, txtdb } from '../../firebase-config';
import {
  onAuthStateChanged
} from "firebase/auth";
import { CiViewList } from "react-icons/ci";
import { FaCheck } from "react-icons/fa6";
import { IoIosWarning } from "react-icons/io";
import { FaCircleCheck } from "react-icons/fa6";
import { BsArrowRight } from "react-icons/bs";
import { LuCalendarClock } from "react-icons/lu";
import { useNavigate } from 'react-router-dom';
import bitlogo from "../../stock/bitcoin-btc-logo.png"

function Investments() {
  const navigate = useNavigate();

  const [user, setUser] = useState({});
const [showLoader, setShowLoader] = useState(false);
const [showSuccess, setShowSuccess] = useState(false);
const [investmentData, setInvestmentData] = useState({});
const [errorPopup, setErrorPopup] = useState(false);
const [errorMessage, setErrorMessage] = useState("");



  useEffect(() => {
    document.title = 'Trades'
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser || null); // Ensures `user` is set to null if `currentUser` is null
    });
  
    // Cleanup function to unsubscribe from the listener when component unmounts
    return () => unsubscribe();
  }, [auth]);


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
         
      } else {
        console.log("No user is logged in.");
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup subscription on component unmount
  }, []);
  
     // State to track if the sidebar is visible
     const [isSidebarVisible, setIsSidebarVisible] = useState(false);

     // Function to handle the click event
     const handleNavClick = () => {
       setIsSidebarVisible(!isSidebarVisible); // Toggle sidebar visibility
     };
 
     const [menuVisible, setMenuVisible] = useState(false);
     const menuRef = useRef(null);
 
       // Toggle menu visibility when button is clicked
   const handleToggleMenu = () => {
     setMenuVisible(!menuVisible);
   };
 
   // Close the menu when clicking outside
   const handleClickOutside = (event) => {
     if (menuRef.current && !menuRef.current.contains(event.target)) {
       setMenuVisible(false);
     }
   };
 
   useEffect(() => {
     document.addEventListener('mousedown', handleClickOutside);
     return () => {
       document.removeEventListener('mousedown', handleClickOutside);
     };
   }, []);

   //tab
  const [currentPage, setCurrentPage] = useState('first');

  //pop up form
  const [showPopup, setShowPopup] = useState(false);

  const goToMarket = () => {
   navigate("/market")
  };

  //duration and shit
  const [investmentName, setInvestmentName] = useState('');
  const [selectedAsset, setSelectedAsset] = useState('');
  const [investmentAmount, setInvestmentAmount] = useState('');
  const [totalBalance, setTotalBalance] = useState(null);
  const [selectedDuration, setSelectedDuration] = useState('');
  const [calculatedReturn, setCalculatedReturn] = useState('');

  // Asset balances in USD
  const [ethereumBalance, setEthereumBalance] = useState(null);
  const [bitcoinBalance, setBitcoinBalance] = useState(null);
  const [usdtBalance, setUsdtBalance] = useState(null);
  const [solBalance, setSolBalance] = useState(null);

  // Interest rates for durations
  const interestRates = {
    '2 weeks': 0.4,
    '1 month': 0.7,
    '1 month, 2 weeks': 1.1,
    '2 months': 2.0,
  };

  const [loading, setLoading] = useState(true);

  const currentUser = auth.currentUser;

  // Fetch balances for each asset
const fetchBalances = async () => {
  if (currentUser) {
    const userId = currentUser.uid;
    try {
      const ethBalanceRef = doc(txtdb, "users", userId, "balances", "Ethereum");
      const btcBalanceRef = doc(txtdb, "users", userId, "balances", "Bitcoin");
      const usdtBalanceRef = doc(txtdb, "users", userId, "balances", "USDT");
      const solBalanceRef = doc(txtdb, "users", userId, "balances", "Solana");

      const ethDocSnap = await getDoc(ethBalanceRef);
      const btcDocSnap = await getDoc(btcBalanceRef);
      const usdtDocSnap = await getDoc(usdtBalanceRef);
      const solDocSnap = await getDoc(solBalanceRef);

      setEthereumBalance(ethDocSnap.exists() ? ethDocSnap.data().balance || 0 : 0);
      setBitcoinBalance(btcDocSnap.exists() ? btcDocSnap.data().balance || 0 : 0);
      setUsdtBalance(usdtDocSnap.exists() ? usdtDocSnap.data().balance || 0 : 0);
      setSolBalance(solDocSnap.exists() ? solDocSnap.data().balance || 0 : 0);

      setLoading(false); // Set loading to false when data is fetched

    } catch (error) {
      console.error("Error fetching balances:", error);
      setLoading(false); // Set loading to false if there is an error
    }
  }
};

  useEffect(() => {
    fetchBalances();
  }, []);

  const togglePopup = () => {
    setShowPopup(!showPopup);
    setSelectedAsset('');
    setInvestmentAmount('');
    setTotalBalance(null);
    setSelectedDuration('');
    setCalculatedReturn('');
    setInvestmentName('');
  };

  const handleAssetChange = (event) => {
    const asset = event.target.value;
    setSelectedAsset(asset);

    if (asset === 'Bitcoin') {
      setTotalBalance(bitcoinBalance);
    } else if (asset === 'Ethereum') {
      setTotalBalance(ethereumBalance);
    } else if (asset === 'USDT') {
      setTotalBalance(usdtBalance);
    } else if (asset === 'Solana') {
      setTotalBalance(solBalance);
    } else {
      setTotalBalance(null);
    }

    setInvestmentAmount('');
    setCalculatedReturn('');
  };

  const handleAmountChange = (event) => {
    const value = event.target.value;

    if (totalBalance !== null && value > totalBalance) {
      setErrorMessage('Trade amount cannot exceed your total balance.');
      setErrorPopup(true);
      return;
    }

    setInvestmentAmount(value);

    if (selectedDuration) {
      const returnAmount = value * (1 + interestRates[selectedDuration]);
      setCalculatedReturn(returnAmount.toFixed(2));
    }
  };

  const handleDurationChange = (event) => {
    const duration = event.target.value;
    setSelectedDuration(duration);

    if (investmentAmount) {
      const returnAmount = investmentAmount * (1 + interestRates[duration]);
      setCalculatedReturn(returnAmount.toFixed(2));
    }
  };

   //balances\
  
//eth balance

const fetchEthereumBalance = async () => {

  if(currentUser){
    const userId = currentUser.uid;
    const ethBalanceRef = doc(txtdb, "users", userId, "balances", "Ethereum");

    try {
      const docSnap = await getDoc(ethBalanceRef);

      if (docSnap.exists()) {
        setEthereumBalance(docSnap.data().balance || 0);
      } else {
        setEthereumBalance(0); // Asset balance does not exist
      }
    } catch (error) {
      console.error("Error fetching Ethereum balance:", error);
    } 
  };

  }

//btc balance


const fetchBitcoinBalance = async () => {

  if(currentUser){
    const userId = currentUser.uid;
    const ethBalanceRef = doc(txtdb, "users", userId, "balances", "Bitcoin");

    try {
      const docSnap = await getDoc(ethBalanceRef);

      if (docSnap.exists()) {
        setBitcoinBalance(docSnap.data().balance || 0);
      } else {
        setBitcoinBalance(0); // Asset balance does not exist
      }
    } catch (error) {
      console.error("Error fetching Bitcoin balance:", error);
    } 
  };

  }

//usdt balance


const fetchUsdtBalance = async () => {

if(currentUser){
  const userId = currentUser.uid;
  const ethBalanceRef = doc(txtdb, "users", userId, "balances", "USDT");

  try {
    const docSnap = await getDoc(ethBalanceRef);

    if (docSnap.exists()) {
      setUsdtBalance(docSnap.data().balance || 0);
    } else {
      setUsdtBalance(0); // Asset balance does not exist
    }
  } catch (error) {
    console.error("Error fetching USDT balance:", error);
  } 
};

}


//sol balance


const fetchSolBalance = async () => {

if(currentUser){
  const userId = currentUser.uid;
  const ethBalanceRef = doc(txtdb, "users", userId, "balances", "Solana");

  try {
    const docSnap = await getDoc(ethBalanceRef);

    if (docSnap.exists()) {
      setSolBalance(docSnap.data().balance || 0);
    } else {
      setSolBalance(0); // Asset balance does not exist
    }
  } catch (error) {
    console.error("Error fetching Solana balance:", error);
  } 
};

}



useEffect(() =>{
fetchEthereumBalance();
fetchBitcoinBalance();
fetchUsdtBalance();
fetchSolBalance();
})

//submission
const handleSubmit = async (event) => {
  event.preventDefault();

  // Validation: Ensure all fields are filled
  if (!investmentName || !selectedAsset || !investmentAmount || !selectedDuration) {
    setErrorMessage('Please fill in all fields.');
    setErrorPopup(true)
    return;
  }

  // Calculate the estimated return
  const durationInterestRates = {
    "2 weeks": 0.4,
    "1 month": 0.7,
    "1 month and 2 weeks": 1.1,
    "2 months": 2.0,
  };

  //duration mapping
  const durationMapping = {
    "2 weeks": 14, // Days
    "1 month": 30,
    "1 month and 2 weeks": 45,
    "2 months": 60,
  };

  // Calculate expiry date
function calculateExpiryDate(startDate, durationInDays) {
  const start = new Date(startDate);
  const expiry = new Date(start);
  expiry.setDate(start.getDate() + durationInDays);
  return expiry.toISOString(); // Return ISO string for consistent formatting
}

const startDate = new Date().toISOString(); // Timestamp of submission
const durationInDays = durationMapping[selectedDuration];
const expiryDate = calculateExpiryDate(startDate, durationInDays);

  const interestRate = durationInterestRates[selectedDuration];
  const estimatedReturn = (investmentAmount * (1 + interestRate)).toFixed(2);

  

  // Prepare data to save
  const dataToSave = {
    investmentName,
    selectedAsset,
    investmentAmount,
    selectedDuration,
    estimatedReturn,
    timestamp: new Date().toISOString(),
    startDate,  // The submission timestamp
    expiryDate, // Calculated expiry date
  };
  setInvestmentData(dataToSave);
  
  try {
    setShowLoader(true);
    // Get current user ID (ensure the user is logged in)
    const currentUser = auth.currentUser;
    if (!currentUser) {
      setErrorMessage('You need to be logged in to submit a Trade.');
      setErrorPopup(true);
      return;
    }

    const userId = currentUser.uid;

    // Save the investment data to Firestore
    const investmentRef = doc(txtdb, "users", userId, "investments", investmentName);
    await setDoc(investmentRef, dataToSave);

    // Fetch the current asset balance from Firestore
    const assetRef = doc(txtdb, "users", userId, "balances", selectedAsset);
    const assetSnap = await getDoc(assetRef);

    if (assetSnap.exists()) {
      const currentBalance = assetSnap.data().balance;

      // Calculate new balance after subtracting the investment amount
      const newBalance = currentBalance - investmentAmount;

      if (newBalance < 0) {
        setErrorMessage('Insufficient balance. Cannot complete this Trade.');
        setErrorPopup(true);
        return;
      }

      // Update the asset balance in Firestore
      await updateDoc(assetRef, {
        balance: newBalance,
      });
     
         // Add transaction history
         const transactionsRef = collection(txtdb, "users", userId, "transactions");
         const transactionData = {
           date: new Date().toISOString(), // ISO format date
           amount: investmentAmount,
           description: `Invested ${selectedAsset} in ${investmentName}`,
           transactionStatus: "Successful",
           category: "Investment",
         };
   
         await addDoc(transactionsRef, transactionData);
      
      // alert('Investment submitted successfully!');
      setShowLoader(false);
      setShowSuccess(true)

    } else {
      setErrorMessage(`Asset ${selectedAsset} does not exist in your balances.`);
      setErrorPopup(true);
    }

    // Clear input fields
    setInvestmentName('');
    setSelectedAsset('');
    setInvestmentAmount('');
    setSelectedDuration('');

    togglePopup(); // Close the popup form after submission
  } catch (error) {
    console.error("Error submitting Trade:", error);
    setErrorMessage('An error occurred while submitting your Trade. Please try again.');
    setErrorPopup(true);
  }
};

//list of investments

// const [investments, setInvestments] = useState([]);

  // const currentUser = auth.currentUser;

//   const fetchInvestments = async () => {

//     if(currentUser){
//       const userId = currentUser.uid; // Ensure user is logged in
//       const investmentsRef = collection(txtdb, "users", userId, "copyTrades");

//       try {
  
//         const q = query(investmentsRef, orderBy("timestamp", "desc"));
//         const querySnapshot = await getDocs(q);
  
//         const fetchedInvestments = querySnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//         }));
  
//         setInvestments(fetchedInvestments);
//       } catch (error) {
//         console.error("Error fetching Trades:", error);
//       }

//     }

//   };
  
//   useEffect(() => {
//   fetchInvestments();
// },); 

useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
    setUser(currentUser || null); // Ensures `user` is set to null if `currentUser` is null
  });

  // Cleanup function to unsubscribe from the listener when component unmounts
  return () => unsubscribe();
}, [auth]);



const deleteExpiredInvestments = async () => {
  const currentUser = auth.currentUser;

  if (currentUser) {
    const userId = currentUser.uid;

    try {
      const investmentsRef = collection(txtdb, `users/${userId}/investments`);
      const deletionLogsRef = collection(txtdb, `users/${userId}/deletionLogs`);

      // Fetch all investments
      const snapshot = await getDocs(investmentsRef);
      const currentDate = new Date();

      for (const docSnapshot of snapshot.docs) {
        const investment = docSnapshot.data();
        const investmentId = docSnapshot.id;

        // Check if the investment's expiry date is in the past and if it is already processed
        if (new Date(investment.expiryDate) < currentDate && !investment.isProcessed) {
          const deletionTime = new Date().toISOString();

          // Update the asset balance
          const assetRef = doc(txtdb, `users/${userId}/balances/${investment.selectedAsset}`);
          const assetSnap = await getDoc(assetRef);

          if (assetSnap.exists()) {
            const currentBalance = assetSnap.data().balance || 0;
            const updatedBalance = currentBalance + parseFloat(investment.estimatedReturn);

            // Update the balance in Firestore
            await updateDoc(assetRef, { balance: updatedBalance });
            console.log(`Updated balance for ${investment.selectedAsset}: ${updatedBalance}`);
          } else {
            console.warn(`Asset ${investment.selectedAsset} does not exist. Skipping balance update.`);
          }

          // Log the deletion using setDoc with the investment ID to avoid duplicates
          await setDoc(doc(deletionLogsRef, investmentId), {
            investmentId,
            deletedAt: deletionTime,
            ...investment, // Include deleted investment details if needed
          });
          console.log(`Logged deletion for ${investment.selectedAsset}`);

          // Add transaction history using setDoc
          const transactionsRef = collection(txtdb, `users/${userId}/transactions`);
          const transactionData = {
            date: new Date().toISOString(),
            amount: investment.estimatedReturn,
            description: `Cashed out ${investment.estimatedReturn} from ${investment.investmentName}`,
            transactionStatus: "Successful",
            category: "Cashback",
          };
          await setDoc(doc(transactionsRef, investmentId), transactionData);
          console.log('Transaction history added successfully');

          // Delete the investment
          await deleteDoc(docSnapshot.ref);
          console.log(`Trade deleted successfully.`);

          // Mark the investment as processed
          await updateDoc(docSnapshot.ref, { isProcessed: true });
        }
      }

      console.log("Expired trades deleted successfully, logged, and balances updated.");
    } catch (error) {
      console.error("Error deleting expired Trades:", error);
    }
  }
};

useEffect(() => {
  // Check for expired investments when the page loads
  deleteExpiredInvestments();
  return
}, []); // Empty dependency array to run only on initial load


//


//copytrades
 const [investments, setInvestments] = useState([]);

  useEffect(() => {
    const fetchCopyTrades = async () => {
      try {
        if (!currentUser?.uid) return;
        const copyTradesRef = collection(txtdb, "users", currentUser.uid, "copyTrades");
        const snapshot = await getDocs(copyTradesRef);

        const fetched = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

        setInvestments(fetched);
      } catch (err) {
        console.error("Error fetching trades:", err);
      }
    };

    fetchCopyTrades();
  }, [currentUser]);


    // tick forces periodic re-render so "now" advances
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setTick((t) => t + 1);
    }, 15000); // update every 15s (use 60000 for 1 minute)
    return () => clearInterval(id);
  }, []);

  //deleted copy trades
const deleteExpiredCopyTrades = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) return;

  const userId = currentUser.uid;

  try {
    const copyTradesRef = collection(txtdb, `users/${userId}/copyTrades`);
    const completedTradesRef = collection(txtdb, `users/${userId}/completedCopyTrades`);
    const transactionsRef = collection(txtdb, `users/${userId}/transactions`);
    const snapshot = await getDocs(copyTradesRef);
    const now = new Date();

    for (const docSnapshot of snapshot.docs) {
      const trade = docSnapshot.data();
      const tradeId = docSnapshot.id;

      const endDate = trade.endDate?.toDate ? trade.endDate.toDate() : new Date(trade.endDate);
      const estimatedReturn = parseFloat(trade.currentAmount) || 0;

      // Skip if invalid end date or already processed
      if (!endDate || trade.isProcessed) continue;

      if (endDate < now) {
        const completionTime = new Date().toISOString();

        // ✅ Update asset balance
        const assetRef = doc(txtdb, `users/${userId}/balances/${trade.asset}`);
        const assetSnap = await getDoc(assetRef);

        if (assetSnap.exists()) {
          const currentBalance = parseFloat(assetSnap.data().balance) || 0;
          const updatedBalance = currentBalance + estimatedReturn;

          await updateDoc(assetRef, { balance: updatedBalance });
          console.log(`Balance updated for ${trade.selectedAsset}: ${updatedBalance.toFixed(2)}`);
        } else {
          console.warn(`Asset ${trade.selectedAsset} not found, skipping balance update.`);
        }

        // ✅ Move to completedCopyTrades
        await setDoc(doc(completedTradesRef, tradeId), {
          ...trade,
          completedAt: completionTime,
        });
        console.log(`Moved ${trade.tradeName || "trade"} to completed trades.`);

        // ✅ Log transaction before deleting
        const transactionData = {
          date: completionTime,
          amount: estimatedReturn.toFixed(2),
          description: `Cashed out $${estimatedReturn.toFixed(2)} from ${trade.traderName || "Copy Trade"}`,
          transactionStatus: "Successful",
          category: "Cashback",
        };
        await setDoc(doc(transactionsRef, tradeId), transactionData);
        console.log("Transaction logged successfully");

        // ✅ Mark as processed before deletion
        await updateDoc(docSnapshot.ref, { isProcessed: true });

        // ✅ Now delete the active trade
        await deleteDoc(docSnapshot.ref);
        console.log(`Deleted expired trade: ${tradeId}`);
      }
    }

    console.log("✅ Expired copy trades moved, logged, and balances updated.");
  } catch (error) {
    console.error("❌ Error processing expired trades:", error);
  }
};

useEffect(() => {
  deleteExpiredCopyTrades();
}, []);

const [completedTrades, setCompletedTrades] = useState()

//fetch completeted trades
useEffect(() => {
  const fetchCompletedTrades = async () => {
    try {
      if (!currentUser?.uid) return;
      const completedRef = collection(txtdb, "users", currentUser.uid, "completedCopyTrades");
      const snapshot = await getDocs(completedRef);

      const completed = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      setCompletedTrades(completed); // new state for completed ones
    } catch (err) {
      console.error("Error fetching completed trades:", err);
    }
  };

  fetchCompletedTrades();
}, [currentUser]);


  return (
    <div className='layout'>
    <DesktopUserNav />

    <div className="content">

    <div className="investments-container container" >

    <div className="navigation-container">

    <NavLink to='/dashboard' className="mobile">
              <img src={logo} alt="nexusforgefx" />
              <p className='name'>Trades</p>
    </NavLink>


     <p className='desktop'>Trades</p>

     <div className="actions desktop" >

     <div className="quick" onClick={handleToggleMenu} >
        Quick Actions 
        <IoIosArrowDown />

        {menuVisible && (
                     <div className="quick-actions" ref={menuRef}>

                     <NavLink to="/withdrawals" className="settings top">
                         <RiSendPlaneLine className='icon' /> Send Money
                     </NavLink>
 
                     <NavLink to="/trades" className="settings">
                         <MdFormatListBulletedAdd  className='icon' /> New Trade
                     </NavLink>
 
                     <NavLink to="/deposits" state={{ currentPage: "convert" }} className="settings">
                         <RiExchangeDollarLine  className='icon'/> Convert Funds
                     </NavLink>
 
                     <NavLink to="/deposits" className="logout">
                         <BiTransfer  className='icon' /> Fund Wallet
                     </NavLink>
 
                     </div>
                )}
        </div>

     <div className="notif">
     <MdNotificationsNone className='icon' />
     </div>
     </div>

     <div className="actions mobile">

     <div className="notif">
     <MdNotificationsNone className='icon' />
     </div>

     <div className="nav"  onClick={handleNavClick}>
     <CgMenuLeft className='icon' />
     </div>

     </div>

    </div>

    {isSidebarVisible && (
      <UserNav onClose={handleNavClick} />
    )}

    </div>

    <div className="pages-content">

        <div className="investments">

        <div className="account-summary-container">
          
          <div className="account-balance">

            <img src={purse} alt="wallet" />

            <div className="balance">
                <h6>My Balance</h6>

                <h1>${usdtBalance !== null || bitcoinBalance !== null || ethereumBalance !== null || solBalance !== null ? (
          <>
           {[
            usdtBalance || 0, 
            bitcoinBalance || 0, 
            ethereumBalance || 0, 
            solBalance || 0,
          ].reduce((acc, balance) => acc + balance, 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}

          </>
        ) : (
          "Loading..."
        )}</h1>

        <h6 className='portfolio'>
          Active Trades Value: <span>
            $
            {investments.reduce((total, investment) => total + Number(investment.currentAmount), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}

            </span> 
        </h6>
            </div>

          </div>

        <div className="new-investment" onClick={goToMarket}>

           <div ><RiPlayListAddLine className='icon'/></div>  <h3>New Trade</h3>


        </div>

        </div>

        <div className="tabs">
        <button className={currentPage === 'first' ? 'active' : ''} onClick={() => setCurrentPage('first')}>Active</button>

        <button className={currentPage === 'second' ? 'active' : ''} onClick={() => setCurrentPage('second')}>Completed</button>

        <NavLink to="/transactions" className='history'><MdHistory className='icon' /> History</NavLink>
        </div>

        <div className="active-investments">

      {currentPage === 'first' && (
        <div className="first">
          <h3>- Active Trades -</h3>

          <div className='active-container'>
            
          {investments.length === 0 ? (
            <p className="nothing">No Active Trades.</p>
          ) : (
            investments.map((investment, index) => {
              const start = investment.startDate?.toDate
            ? investment.startDate.toDate()
            : new Date(investment.startDate);
          const end = investment.endDate?.toDate
            ? investment.endDate.toDate()
            : new Date(investment.endDate);
          const now = new Date();

          const totalDuration = end - start;
          const elapsed = now - start;
          const progressPercentage =
            totalDuration > 0
              ? Math.min((elapsed / totalDuration) * 100, 100)
              : 0;
            
          // days left (raw)
          const msPerDay = 1000 * 60 * 60 * 24;
          const timeLeftMs = end - now;
          const daysLeftRaw = timeLeftMs / msPerDay;
          // you asked for two decimals like "20.00"
          const daysLeftFormatted = Math.max(daysLeftRaw, 0).toFixed(0);

          // If you want integer days (rounded up) with .00:
          // const daysLeftFormatted = Math.max(Math.ceil(daysLeftRaw), 0).toFixed(2);

          // show currentAmount (if you store it) or investedAmount fallback


              return (
                <div key={investment.id} className="investment-item">

                  <div className="name-asset">
                      
                      <div className="details">
                    <p title="Asset Traded" class="Asset-Invested" >{investment.asset} </p>

                    <h4 title="Trader Copied"> <span>Copy Trading:</span> {investment.traderName}</h4>
                    <p className="amount-return">
                    $ {investment.investedAmount.toFixed(2)} <BsArrowRight /> <span>
                       $ {investment.currentAmount.toFixed(2)}
                      </span>
                    </p>
                      </div>


                  </div>

                  <div className="progress-container">

                  <div className="progress">
                    <div className="progress-bar" style={{ width: `${progressPercentage}%` }}></div>
                  </div>
                    <p className="progress-percentage">{progressPercentage.toFixed(2)}%</p>
                    
                    </div>

                      <div className="amount-duration">
              <div className="duration-details">
             
               {daysLeftFormatted}Days to go (
                {investment.startDate?.toDate
                  ? new Date(investment.startDate.toDate()).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })
                  : "N/A"}{" "}
                -{" "}
                {investment.endDate?.toDate
                  ? new Date(investment.endDate.toDate()).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })
                  : "N/A"}
                )
              </div>
            </div>


                 

                </div>
              );
            })
          )}

        </div>

        </div>
      )}


    {currentPage === 'second' && (
        <div className="second">
          <h3>- Completed Trades -</h3>

          <div className='active-container'>
            
            {completedTrades.length === 0 ? (
              <p className="nothing">No Completed Trades.</p>
            ) : (
              completedTrades.map((completedTrades, index) => {
                const startDate = new Date(completedTrades.timestamp);
                const expiryDate = new Date(completedTrades.expiryDate);
                const currentDate = new Date();
  
                // Calculate progress percentage
                const totalDuration = expiryDate - startDate;
                const timeElapsed = currentDate - startDate;
                const progressPercentage = Math.min((timeElapsed / totalDuration) * 100, 100); // Cap at 100%
  
                return (
                  <div key={completedTrades.id} className="investment-item">

                 <div className="name-asset">

                      <div className="details">
                    <p title="Asset Traded" class="Asset-Invested" >{completedTrades.asset}</p>
                    <h4 title="Trader Copied"><span>Copy Traded:</span> {completedTrades.traderName}</h4>
                    <p className="amount-return">
                     ${completedTrades.investedAmount} <BsArrowRight   /> <span>
                       ${completedTrades.currentAmount}
                      </span> 
                    </p>
                      </div>


                  </div>

                  <div className="progress-container">
  
                <div className="progress">
                  <div className="progress-bar" style={{ width: `${progressPercentage}%` }}></div>
                </div>
                  {/* <p className="progress-percentage">{progressPercentage.toFixed(2)}%</p> */}
                  <p className="progress-percentage complete"> <FaCircleCheck className='completed-icon'/> Completed</p>

                  
                  </div>
                  <div className="amount-duration">

                   <div className="duration-details">
                    {completedTrades.durationDays} Days (
                    {completedTrades.startDate?.toDate
                      ? new Date(completedTrades.startDate.toDate()).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })
                      : "N/A"}{" "}
                    -{" "}
                    {completedTrades.endDate?.toDate
                      ? new Date(completedTrades.endDate.toDate()).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })
                      : "N/A"}
                    )
                  </div>

                  </div>
                  <div className='re'>Completed and Added to {completedTrades.asset} Balance</div>
  
     
                      
                    
                  </div>
                );
              })
            )}
  
          </div>

        </div>
      )}

        </div>

        </div>

    </div>

    </div>


    {showPopup && (
        <div className="overlay">
          <div className="popup">
            <button onClick={togglePopup} className="close-button">
              ×
            </button>
            <h3>New Trade</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Trade Name:</label>
                <input
                  type="text"
                  placeholder="Enter Trade name"
                  value={investmentName}
                  onChange={(e) => setInvestmentName(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Choose Asset:</label>
                <select value={selectedAsset} onChange={handleAssetChange}>
                  <option value="">Select an asset</option>
                  <option value="Bitcoin">Bitcoin (BTC)</option>
                  <option value="Ethereum">Ethereum (ETH)</option>
                  <option value="USDT">Tether (USDT)</option>
                  <option value="Solana">Solana (SOL)</option>
                </select>
              </div>

              {totalBalance !== null && (
                <div className="form-group">
                  <label>Total Balance (USD):</label>
                  <input
                    type="text"
                    value={`$${totalBalance}`}
                    readOnly
                    className="readonly-input"
                  />
                </div>
              )}

              {selectedAsset && (
                <div className="form-group">
                  <label>Trade Amount:</label>
                  <input
                    type="number"
                    placeholder="Enter amount"
                    value={investmentAmount}
                    onChange={handleAmountChange}
                    max={totalBalance || ''}
                  />
                </div>
              )}

              {investmentAmount && (
                <div className="form-group">
                  <label>Choose Duration:</label>
                  <select value={selectedDuration} onChange={handleDurationChange}>
                    <option value="">Select a duration</option>
                    <option value="2 weeks">2 Weeks (40% Interest)</option>
                    <option value="1 month">1 Month (70% Interest)</option>
                    <option value="1 month, 2 weeks">1 Month, 2 Weeks (110% Interest)</option>
                    <option value="2 months">2 Months (200% Interest)</option>
                  </select>
                </div>
              )}

              {calculatedReturn && (
                <div className="form-group">
                  <label>Estimated Return (USD):</label>
                  <input
                    type="text"
                    value={`$${calculatedReturn}`}
                    readOnly
                    className="readonly-input"
                  />
                </div>
              )}

              <button type="submit" disabled={!selectedDuration || !investmentAmount || !investmentName}>
                Submit
              </button>
            </form>
          </div>
        </div>
      )}

{showLoader && (
        <div className="loader">
          <div className="spinner">
            <div></div>   
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
          </div>


        </div>
      )}

{showSuccess && (
        <div className="loader">
          

          <div className="receit-container">

              <div className="success-message">
                <div className='icon-con'>
              <FaCheck className='icon' />
                </div>
              <h2>Success</h2>
              <p>Your Trade has been successfully submitted.</p>
              </div>

              <div className="investment-details">

                <div className="amount">
                  <h2>${investmentData.investmentAmount}</h2>
                  <p>Traded amount</p>
                </div>

                <div className="other">

                  <ol>
                 <span>From:</span>
                 <span>  {new Date(investmentData.timestamp).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}{" "}</span>
                  </ol>

                  <ol>
                 <span>To:</span>
                 <span>  {new Date(investmentData.expiryDate).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}{" "}</span>
                </ol>

                  <ol>
                 <span>Asset Used:</span>
                 <span>{investmentData.selectedAsset}</span>
                  </ol>

                  <ol>
                 <span>Returns:</span>
                 <span>${investmentData.estimatedReturn}</span>
                  </ol>

                </div>

             <div className="buttons">

                <NavLink to='/transactions'>
                  <CiViewList /> View Transaction
                </NavLink>

                <button  onClick={() => setShowSuccess(false)}>Done</button>
             </div>


              </div>

          </div>


        </div>
      )}

      {errorPopup && (
        <div className="overlay">
          <div className="popup">

        <div className="error-container">

          <div className="con">
            <IoIosWarning className='iconn' />
          </div>
            
            <h4 className='warningheader'>oops... An Error occured</h4>

            <p>{errorMessage}</p>

            <button onClick={() => setErrorPopup(false)} className="close">
              Close
            </button>

        </div>
          </div>
        </div>
      )

      }

  </div>
  )
}

export default Investments